import Repository from "./Repository";
import { TrainingGroup } from "../types/TrainingGroup";

const resource = "/trainingGroup";

export default {
  save(group: TrainingGroup) {
    if (group.trainingGroupId) {
      return Repository.patch(`${resource}`, group);
    } else {
      return Repository.post(`${resource}`, group);
    }
  }
};
